import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import emailjs from "@emailjs/browser";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Socials from "../components/about/socials";
import Experience from "../pages/experience";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/about.css";

const EMAILJS_SERVICE_ID = "service_jpezr0s";
const EMAILJS_TEMPLATE_ID = "template_o1mox8p";
const EMAILJS_PUBLIC_KEY = "Qc73pj33bbA0EKVxQ";

const About = () => {
	const [enquiry, setEnquiry] = useState({ name: "", email: "", message: "" });
	const [formStatus, setFormStatus] = useState("idle");

	const sendEnquiry = async (event) => {
		event.preventDefault();
		setFormStatus("sending");
		try {
			await emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, {
				to_email: INFO.main.email,
				from_name: enquiry.name.trim(),
				from_email: enquiry.email.trim(),
				reply_to: enquiry.email.trim(),
				message: enquiry.message.trim(),
				subject: "Website enquiry from the About page",
			}, EMAILJS_PUBLIC_KEY);
			setEnquiry({ name: "", email: "", message: "" });
			setFormStatus("success");
		} catch (error) {
			console.error("About page enquiry failed:", error);
			setFormStatus("error");
		}
	};

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "about");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`About | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="about" />
				<div className="content-wrapper">
					<div className="about-logo-container">
						<div className="about-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="about-container">
						<div className="about-main">
							<div className="about-right-side">
								<h1 className="title about-title">
									{INFO.about.title}
								</h1>

								<div className="subtitle about-subtitle">
									Jabu Zwane is an award-winning keynote speaker, executive coach and facilitator who helps people and organisations communicate with clarity, lead with confidence and create meaningful change.
								</div>
								<div className="about-highlights" aria-label="Jabu Zwane highlights">
									<span><strong>1,000+</strong> talks delivered</span>
									<span><strong>50+</strong> organisations supported</span>
									<span><strong>10</strong> countries reached</span>
								</div>
								<div className="about-enquiry-card">
									<div className="about-enquiry-card__heading">
										<span>Start a conversation</span>
										<h2>Bring Jabu to your next event.</h2>
										<p>Share a few details and the team will respond by email.</p>
									</div>
									<form className="about-enquiry-form" onSubmit={sendEnquiry}>
										<label>Your name<input required value={enquiry.name} onChange={(event) => setEnquiry({ ...enquiry, name: event.target.value })} placeholder="Name" disabled={formStatus === "sending"} /></label>
										<label>Email address<input required type="email" value={enquiry.email} onChange={(event) => setEnquiry({ ...enquiry, email: event.target.value })} placeholder="you@example.com" disabled={formStatus === "sending"} /></label>
										<label className="about-enquiry-form__message">How can Jabu help?<textarea required rows={4} value={enquiry.message} onChange={(event) => setEnquiry({ ...enquiry, message: event.target.value })} placeholder="Tell us about your event, team or opportunity." disabled={formStatus === "sending"} /></label>
										<button type="submit" disabled={formStatus === "sending"}>{formStatus === "sending" ? "Sending…" : "Send enquiry"}</button>
										{formStatus === "success" && <p className="about-enquiry-form__notice is-success">Thanks — your enquiry has been sent to info@jabuzwane.co.za.</p>}
										{formStatus === "error" && <p className="about-enquiry-form__notice is-error">We could not send your enquiry. Please email info@jabuzwane.co.za directly.</p>}
									</form>
								</div>
							</div>

							<div className="about-left-side">
								<div className="about-image-container">
									<div className="about-image-wrapper">
										<img
											src="4.jpeg"
											alt="Jabu Zwane speaking at an event"
											className="about-image"
										/>
									</div>
								</div>

								<div className="about-socials">
									<Socials />
								</div>
							</div>
						</div>
						<div className="about-socials-mobile">
							<Socials />
						</div>

						<Experience />
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default About;